import React, { useState, useEffect, useContext } from 'react';
import { format, isBefore, subDays, startOfMonth, isSameDay } from 'date-fns';
import { DayPicker } from 'react-day-picker';
import heLocale from 'date-fns/locale/he';
import 'react-day-picker/dist/style.css';
import MyDateTime from './MyDateTime';
import { MasterContext } from '../Contexts/Master_Context';
import TimesListSelections from './TimesListSelections';



const DateTimePick = (props) => {
    const [mastercon, setMastercon] = useContext(MasterContext);
    const [selectedDate, setSelectedDate] = useState(null);
    const [displayedMonth, setDisplayedMonth] = useState(startOfMonth(new Date()));
    const [unavailabledays, setUnavailabledays] = useState([]);
    const [timeToCome, setTimeToCome] = useState("")
    const [fromOpening, setFromOpening] = useState("00:00")
    const [toClosing, setToClosing] = useState("00:00")
    const [currnetDayHoursApprov, setCurrnetDayHoursApprov] = useState([])
    const [panelDisp, setPanelDisp] = useState(0);

    useEffect(() => {
        setUnavailabledays(getUnavaildDays());

    }, []);

    useEffect(() => {
        if (selectedDate &&
            timeToCome) {
            props.selectedDate(MyDateTime.getDate(selectedDate) + " " + timeToCome)
        }
        else { props.selectedDate("") }

    }, [selectedDate, timeToCome]);

    //נבחר תאריך להזמנה
    const dateToComeChanged = (val) => {
        setSelectedDate(val);
        setCurrnetDayHoursApprov(getHoursApproveByDay(val));
        setPanelDisp(1);
    }


    const handleMonthChange = (date) => {
        setDisplayedMonth(startOfMonth(date));
    };


    //ימים שהמסעדה לא פתוחה
    const getUnavaildDays = () => {
        let closedDays = mastercon.availableOrderTimes.map((dayItm, i) => MyDateTime.getTime(dayItm.Open) === "00:00:00" &&
            MyDateTime.getTime(dayItm.Close) === "00:00:00"
            ? MyDateTime.getDayOfWeekByDayNum(i + 1)
            : null)
            .filter(day => day !== null);

        return (closedDays)
    }


    //בודק ימים חסומים
    const isDayDisabled = (day) => {
        // השבת ימים לפני היום (כולל היום)
        if (isBefore(day, subDays(new Date(), 0))) {
            return true;
        }
        // השבת ימים שהוגדרו כרשימת unavailabledays (לפי יום בשבוע)
        if (
            unavailabledays?.includes(MyDateTime.getDayOfWeekByDayNum(day.getDay() + 1))
        ) {
            return true;
        }
        // השבת ימים שיש ברשימת dateSpecilsBlocks אובייקט עם תאריך (dateVal) התואם ליום זה
        if (
            mastercon.dateSpecilsBlocks &&
            mastercon.dateSpecilsBlocks.some((block) =>
                isSameDay(new Date(block.dateVal), day)
            )
        ) {
            return true;
        }

        return false;
    };

    //נבחרה שעה להזמנה
    const timeToComeChanged = (val) => {
        setTimeToCome(val);

    }



    //מושך שעות מאושרות להזמנה על ידי תאריך הבקשה
    const getHoursApproveByDay = (val) => {

        let opHrs = mastercon.availableOrderTimes.filter((curDt, i) =>
            curDt.Day === MyDateTime.getDayOfWeek(val));

        if (opHrs.length === 0) {
            return []; // Handle case when opening hours for the current day are not found
        }

        const intervalInMinutes = 30;

        let theFullTmLstCreated = [];

        // Calculate previous day
        const previousDay = MyDateTime.getYesterday(val, 1);

        // Find opening hours for the previous day
        let prevOpHrs = mastercon.availableOrderTimes.find((curDt) =>
            curDt.Day === previousDay);

        if (prevOpHrs) {
            const prevCloseTime = MyDateTime.getTime(prevOpHrs.Close);
            if (prevCloseTime > "00:00:00" && prevCloseTime <= "05:00:00") { // Check if previous day's close time is after midnight
                const startTimList = generateTimeList("00:00:00", prevCloseTime, intervalInMinutes, fromOpening, toClosing);
                theFullTmLstCreated = theFullTmLstCreated.concat(startTimList);
            }
        }


        const openTime = MyDateTime.getTime(opHrs[0].Open);
        let closeTime = MyDateTime.getTime(opHrs[0].Close);


        let toclsTime = (closeTime >= "00:00:00" && closeTime <= "05:00:00") ? "00:00:00" : toClosing;
        closeTime = (closeTime >= "00:00:00" && closeTime <= "05:00:00") ? "00:00:00" : closeTime;
        closeTime = (closeTime === "00:00:00") ? "23:59:59" : closeTime;


        // Generate time list for the current day
        let currtDayLst = generateTimeList(openTime, closeTime, intervalInMinutes, fromOpening, toClosing);
        // Merge time lists for the previous day and the current day
        theFullTmLstCreated = theFullTmLstCreated.concat(currtDayLst);
        return theFullTmLstCreated;

    }

    //יוצר רשימת שעות אפשריות לבחירה לפי שעות פתיחה של היום הנבחר
    const generateTimeList = (openTime, closeTime, intervalInMinutes, fromOpening, fromClosing) => {
        const timeList = [];
        let currentTime = new Date();
        const closeTimeObj = new Date();

        const [hours, minutes, seconds] = openTime.split(':');
        const [Clhours, Clminutes, Clseconds] = closeTime.split(':');

        const [fromOpeningHours, fromOpeningMinutes] = fromOpening.split(':');
        const [fromClosingHours, fromClosingMinutes] = fromClosing.split(':');

        // Subtract fromOpening time
        currentTime.setHours(parseInt(hours, 10) + parseInt(fromOpeningHours, 10));
        currentTime.setMinutes(parseInt(minutes, 10) + parseInt(fromOpeningMinutes, 10));
        currentTime.setSeconds(seconds);

        closeTimeObj.setHours(parseInt(Clhours, 10) - parseInt(fromClosingHours, 10));
        closeTimeObj.setMinutes(parseInt(Clminutes, 10) - parseInt(fromClosingMinutes, 10));
        closeTimeObj.setSeconds(Clseconds);

        while (currentTime <= closeTimeObj) {
            timeList.push(currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));

            // Clone the currentTime object before modifying it
            const newTime = new Date(currentTime);

            // Update the cloned object
            newTime.setMinutes(newTime.getMinutes() + intervalInMinutes);

            // Update currentTime with the cloned object
            currentTime = newTime;
        }

        return timeList;
    };





    return (
        <div className='inPanelRes'>
            <div className={"tmAndhouSeletions fullRow"}>
                <button className={`${panelDisp === 0 && "active"} bottomBrd_effect pointing inColorgoldLine fontsize1-5 onRight`}
                    onClick={() => setPanelDisp(0)}>{selectedDate ? MyDateTime.getDate(selectedDate) : "בחרו תאריך"}
                </button>
                {selectedDate &&
                    <button className={`${panelDisp === 1 && "active"} bottomBrd_effect pointing inColorgoldLine fontsize1-5 onLeft`}
                        onClick={() => setPanelDisp(1)}>{timeToCome ? timeToCome : "בחרו שעה"}
                    </button>
                }
            </div>
            <div className={"claerlineSpacer"}></div>
            {panelDisp === 0 ?
                <>
                    <div className={'mydtPicker'}>
                        <DayPicker
                            mode="single"
                            dir="rtl"
                            locale={heLocale}
                            selected={selectedDate}
                            modifiers={{ disabled: isDayDisabled }}
                            onDayClick={(day, { disabled }) => !disabled && dateToComeChanged(day)}
                            month={displayedMonth}
                            onMonthChange={(date) => handleMonthChange(date)}
                        />
                    </div>
                </>
                :
                <>

                    <div className={'mydtPicker'}>
                        <TimesListSelections
                            settingFunc={(val) => timeToComeChanged(val)}
                            hoursList={currnetDayHoursApprov}
                            Css="inputsStyle pointing"
                            timeSelected={timeToCome}

                        />
                    </div>
                </>
            }
        </div >
    );
};

export default DateTimePick;
